import { ComponentProps } from '@episerver/spa-core/EpiComponent';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import RGEAuthenticationData from '../../../Models/Content/RGEAuthenticationBlockData';
import React, { useEffect, useState } from 'react';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import Config from '../../../Config';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import ProviderManager from './../../../provider/providerManager';
import { connect } from 'react-redux';

const RGEAuthentication = (props) => {

  const [iframeUrl, setIframUrl] = useState('');

  useEffect(() => {
    props.showAppLoader();
    getUserInfoForRge();

  }, []);


  const getUserInfoForRge = async () => {

    try {
      const result = await ProviderManager.getProviderData('GetSubscriberForRge', []);

      if (result.Body && result.Body.subscriberId) {
        let query = `?id=${encodeURIComponent(result.Body.subscriberId)}`;
        window.location.replace(props.data.iframePage.value.url + query);
      }


    } catch (error) {
      console.info('rge authentication error', error);
      return null;
    } finally {
      props.hideAppLoader();
    }
  };


  return (
    <div className="rge-auth"></div>
  );
};

const mapStateToProps = (state) => {

  return {
    loader: state.loader
  }
}

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader
}

export default connect(mapStateToProps, mapDispatchToProps)(RGEAuthentication)


